import styled, { css } from 'styled-components';

import { TStyledContainerProperties } from './container.types';

export const StyledContainer = styled.div<TStyledContainerProperties>`
    width: 100%;
    padding: ${({ fullWidth }) => (fullWidth ? '0' : '0 1.5')}rem;
    ${({ autoAlign }) => autoAlign && 'margin: 0 auto;'};

    ${properties =>
        properties.narrow
            ? css`
                  @media (min-width: ${properties.theme.deprecatedScreen
                          .tabletPortraitMinimum}) {
                      max-width: 47.2rem;
                  }

                  @media (min-width: ${properties.theme.deprecatedScreen
                          .tabletLandscapeMinimum}) {
                      max-width: 62rem;
                  }
              `
            : css`
                  @media (min-width: ${properties.theme.deprecatedScreen
                          .tabletLandscapeMinimum}) {
                      max-width: 94.4rem;
                  }

                  @media (min-width: ${properties.theme.deprecatedScreen
                          .desktopMinimum}) {
                      max-width: 117rem;
                  }
              `}
`;
